import { Sidebar, Menu, MenuItem, SubMenu, menuClasses } from 'react-pro-sidebar';
import { useCollection } from '../hooks/useCollection';
import { useState } from "react";
import { Link } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import dig_logo from '../assets/dig_logo2.png'
import PersonIcon from '@mui/icons-material/Person';
import PieChartIcon from '@mui/icons-material/PieChart';
import SourceIcon from '@mui/icons-material/Source';
import { Button, Divider } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setAllUsers } from '../context/userSlice';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';
import {useAdminActions} from '../hooks/useAdminActions'
import AddIcon from '@mui/icons-material/Add';
import InputModal from '../components/InputModal';
import NewUserForm from './NewUserForm';
import SendIcon from '@mui/icons-material/Send';
import SendMessageForm from '../components/SendMessageForm';


function MySideBar() {
    const [sideBartheme] = useState('dark')
    const [searchString, setSearchString] = useState('')
    const { data: users } = useCollection('/Users')
    const { data: companies } = useCollection('/Companies')
    const dispatch = useDispatch()
    const { user } = useAuthContext()
    const [collapsed, setCollapsed] = useState(false);
    const { updateUser } = useAdminActions()
    const [showNewUserFormModal, setShowNewUserFormModal] = useState(false)
    const [showSendMessageModal, setShowSendMessageModal] = useState(false)

    function getCompanyId() {
        let foundCompany = companies && companies.filter(c => c.adminEmail === user.email)
        if (foundCompany && foundCompany.length > 0) {
            return foundCompany[0].id
        }
        return null
    }
    const companyId = getCompanyId()
    // const companyId = useSelector((state) => state.company.id);

    const themes = {
        light: {
            sidebar: {
                backgroundColor: '#fff',
                color: '#607489',
            },
            menu: {
                menuContent: '#fbfcfd',
                icon: '#0098e5',
                hover: {
                    backgroundColor: '#e6f2fd',
                    color: '#44596e',
                },
                active: {
                    backgroundColor: '#13395e',
                    color: '#b6c8d9',
                },
                disabled: {
                    color: '#3e5e7e',
                },
            },
        },
        dark: {
            sidebar: {
                backgroundColor: '#1976d2',//'#0b2948',
                color: 'white',
            },
            menu: {
                menuContent: '#1976d2',
                icon: '#59d0ff',
                hover: {
                    backgroundColor: '#1565c0',
                    color: '#b6c8d9',
                },
                active: {
                    backgroundColor: '#13395e',
                    color: '#b6c8d9',
                },
                disabled: {
                    color: '#3e5e7e',
                },
            },
        },
    };

    const menuItemStyles = {
        root: {
            fontSize: '13px',
            fontWeight: 400,
        },
        icon: {
            color: 'white'// themes[theme].menu.icon,
        },
        SubMenuExpandIcon: {
            color: '#b6b7b9',
        },
        subMenuContent: {
            backgroundColor: themes[sideBartheme].menu.menuContent,
        },
        button: {
            [`&.${menuClasses.active}`]: {
                backgroundColor: themes[sideBartheme].menu.active.backgroundColor,
                color: themes[sideBartheme].menu.active.color,
            },
            [`&.${menuClasses.disabled}`]: {
                color: themes[sideBartheme].menu.disabled.color,
            },
            '&:hover': {
                backgroundColor: themes[sideBartheme].menu.hover.backgroundColor,
                color: themes[sideBartheme].menu.hover.color,
            },
        },
        label: ({ open }) => ({
            fontWeight: open ? 600 : undefined,
        }),
    };


    var filteredUsers = users && users.filter(u => u.companyid === companyId)
    filteredUsers && filteredUsers.map(u => {
        if (u.usergroup === undefined || !u.usergroup) {
            var userDetail = {...u}
            userDetail.usergroup = 'Brukere'
            updateUser(userDetail)
        }
        return null
    })

    dispatch(setAllUsers(filteredUsers))

    let uGroups = filteredUsers && filteredUsers.map(user => (
        user.usergroup
    ))

    const uniqueGroups = []
    uGroups && uGroups.map(group => {
        if (uniqueGroups.indexOf(group) === -1) {
            uniqueGroups.push(group)
        }
        return null
    });

    const handleSearch = (e) => {
        setSearchString(e.target.value.toUpperCase())
        // let searchString = e.target.value
        // filteredUsers = filteredUsers.filter((u) => u.name.startsWith(searchString))
    }

    const handleShowNewUser = () => {
        setShowNewUserFormModal(true)
    }

    const handleCollapse = () => {
        setCollapsed(!collapsed)
    }

    const handleCloseModal = () => {
        setShowNewUserFormModal(false)
        setShowSendMessageModal(false)
    }

    const handleSendMessage = () => {
        setShowSendMessageModal(true)
    }

    const handleCloseSendMessageForm = () => {
        setShowSendMessageModal(false)
    }

    const handleCloseNewUserForm = () => {
        setShowNewUserFormModal(false)       
    }

    const customTheme = (outerTheme) =>
        createTheme({
            palette: {
                mode: outerTheme.palette.mode,
            },
            components: {
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            '--TextField-brandBorderColor': '#B2BAC2',
                            '--TextField-brandBorderHoverColor': '#B2BAC2',
                            '--TextField-brandBorderFocusedColor': '#B2BAC2',
                            '& label.Mui-focused': {
                                color: 'var(--TextField-brandBorderFocusedColor)',
                            },
                        },
                    },
                },
                MuiOutlinedInput: {
                    styleOverrides: {
                        notchedOutline: {
                            borderColor: 'var(--TextField-brandBorderColor)',
                        },
                        root: {
                            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
                                borderColor: 'var(--TextField-brandBorderHoverColor)',
                            },
                            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
                                borderColor: 'var(--TextField-brandBorderFocusedColor)',
                            },
                        },
                    },
                },
                MuiFilledInput: {
                    styleOverrides: {
                        root: {
                            '&:before, &:after': {
                                borderBottom: '2px solid var(--TextField-brandBorderColor)',
                            },
                            '&:hover:not(.Mui-disabled, .Mui-error):before': {
                                borderBottom: '2px solid var(--TextField-brandBorderHoverColor)',
                            },
                            '&.Mui-focused:after': {
                                borderBottom: '2px solid var(--TextField-brandBorderFocusedColor)',
                            },
                        },
                    },
                },
                MuiInput: {
                    styleOverrides: {
                        root: {
                            '&:before': {
                                borderBottom: '2px solid var(--TextField-brandBorderColor)',
                            },
                            '&:hover:not(.Mui-disabled, .Mui-error):before': {
                                borderBottom: '2px solid var(--TextField-brandBorderHoverColor)',
                            },
                            '&.Mui-focused:after': {
                                borderBottom: '2px solid var(--TextField-brandBorderFocusedColor)',
                            },
                        },
                    },
                },
            },
        });

    const outerTheme = useTheme();

    return (
        <Sidebar collapsed={collapsed}
            backgroundColor={themes[sideBartheme].sidebar.backgroundColor}
            rootStyles={{
                color: themes[sideBartheme].sidebar.color
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 15vw)' }}>

                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: 15,
                    marginRight: 10
                    // alignItems: 'center'
                }}>
                    <Tooltip title="Minimer/maksimer sidemeny">
                        <IconButton
                            size="small"
                            aria-label="chevronleft"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleCollapse}
                            color="inherit"
                        >
                           {collapsed ? <ChevronRightIcon/> : <ChevronLeftIcon />} 
                        </IconButton>
                    </Tooltip>
                </div>
                <Divider style={{ marginTop: 15 }} />

                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    // marginTop: 10,
                    alignItems: 'center'
                }}>
                    <img src={dig_logo} alt="D.I.G" height={100} width={180} />


                </div>
                <Divider style={{ marginTop: 10 }} />

                <div style={{ flex: 1, marginBottom: '10px', marginTop: 30 }}>

                    <Menu menuItemStyles={menuItemStyles}>
                        <MenuItem icon={<SourceIcon />} component={<Link to="/programadmin" />}>Programadministrasjon</MenuItem>
                        <MenuItem icon={<PieChartIcon/>} component={<Link to="/allstatsreports" />}>Statistikk</MenuItem>
                        <Divider style={{ margin: 10 }} />
                        <MenuItem icon={<SendIcon/>} component={<Button onClick={handleSendMessage} sx={{textTransform: 'none', fontSize: '13px', fontWeight: '400'}} />}>Send gruppemelding</MenuItem>
                        <MenuItem icon={<AddIcon/>} component={<Button onClick={handleShowNewUser} sx={{textTransform: 'none', fontSize: '13px', fontWeight: '400'}} />}>Ny bruker</MenuItem>
                        <div style={{ padding: 10 }}>
                            <ThemeProvider theme={customTheme(outerTheme)}>
                                <TextField
                                    id="outlined-basic"
                                    label="Søk"
                                    variant="outlined"
                                    size="small"
                                    onChange={handleSearch}
                                    fullWidth
                                    // color='primary'
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start" >
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{
                                        '& .MuiInputAdornment-root': {
                                            color: '#B2BAC2',
                                        },
                                        '& .MuiFormLabel-root': {
                                            color: '#B2BAC2'
                                        },
                                        '& .MuiInputBase-input': {
                                            color: 'whitesmoke'
                                        }
                                    }}
                                />
                            </ThemeProvider>
                        </div>
                        {uniqueGroups && uniqueGroups.map(group => (
                            <SubMenu defaultOpen label={group} key={group}>
                                {filteredUsers && filteredUsers.filter(u => u.usergroup === group)
                                    .filter((u) => u.name.toUpperCase().startsWith(searchString))
                                    .map(user => (
                                        <MenuItem icon={<PersonIcon />} key={user.id} component={<Link to={`/userdetail/${user.id}`} />}>{user.name}</MenuItem>
                                    ))}
                            </SubMenu>
                        ))}
                    </Menu>
                </div>
            </div>
            {showNewUserFormModal &&
                (<InputModal title="Legg til ny bruker" handleCloseModal={handleCloseModal}>
                    <NewUserForm updateUser={updateUser} handleCloseNewUserForm={handleCloseNewUserForm}/>
                </InputModal>)
            }
            {showSendMessageModal &&
                (<InputModal title="Send melding" handleCloseModal={handleCloseModal}>
                    <SendMessageForm handleCloseSendMessageForm={handleCloseSendMessageForm} isGroupMessage={true}/>
                </InputModal>)
            }
        
        </Sidebar>
        
    )
}

export default MySideBar;